/**
 * Two-factor authentication (2FA) schemas.
 *
 * TOTP-based 2FA enable/disable/verify flow.
 */
import { z } from 'zod';

/** POST /api/users/2fa/enable — generate secret + QR URI. */
export const TwoFactorEnableSchema = z.object({
  // No body required — server generates the secret.
});
export type TwoFactorEnableRequest = z.infer<typeof TwoFactorEnableSchema>;

/** POST /api/users/2fa/verify — confirm setup with a TOTP code. */
export const TwoFactorVerifySchema = z.object({
  code: z.string().length(6).regex(/^\d{6}$/, 'Must be a 6-digit code'),
});
export type TwoFactorVerifyRequest = z.infer<typeof TwoFactorVerifySchema>;

/** POST /api/users/2fa/disable — disable 2FA with a TOTP code. */
export const TwoFactorDisableSchema = z.object({
  code: z.string().length(6).regex(/^\d{6}$/, 'Must be a 6-digit code'),
});
export type TwoFactorDisableRequest = z.infer<typeof TwoFactorDisableSchema>;
